import React, { useEffect, useState } from "react";
import "./Product_Rating.css";
import { Modal } from "react-bootstrap";
import Average_Rating from "./average_Rating/Average_Rating";
import Submit_Your_Review from "./submit_Your_Review/Submit_Your_Review";
import Customer_Feedbacks from "./customer_Feedbacks/Customer_Feedbacks";
import {
  allReviewRating,
  AvgReviewRating,
} from "../../../features/review_rating/review_ratingSlice";
import { useDispatch, useSelector } from "react-redux";
import Green_btn from "../../common-components/common_btn/green_btn/Green_btn";
import {
  faStar,
  faStarHalfStroke,
  faStar as faStarSolid,
} from "@fortawesome/free-solid-svg-icons";
import { faStar as faStarRegular } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Success_Modal from "../../common-components/common_modal/success_modal/Success_Modal";
import { myAccount } from "../../../features/my_account/Slice";
function Product_Rating({ product }) {
  const dispatch = useDispatch();
  const avg_rating = useSelector((state) => state.reviewRating.avg_rating);
  const averageRating = Number(avg_rating?.average_rating || 0);
  useEffect(() => {
    dispatch(AvgReviewRating({ product_id: product.id }));
  }, [dispatch, product]);
  const all_rating = useSelector((state) => state.reviewRating.all_rating);
  const totalReviews = all_rating?.data?.length || 0;
  useEffect(() => {
    dispatch(allReviewRating({ product_id: product.id }));
  }, [dispatch, product]);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const handleCloseReviewModal = () => setShowReviewModal(false);
  const handleShowReviewModal = () => setShowReviewModal(true);
  const user = useSelector((state) => state.myaccount.addMyaccount);
  const hasReviewed = all_rating?.data?.some(
    (review) => review.user_id === user.id,
  );
  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => {
      const star = index + 1;
      if (rating >= star) {
        return (
          <FontAwesomeIcon
            key={index}
            icon={faStarSolid}
            className="rating-star"
          />
        );
      }
      if (rating >= star - 0.5) {
        return (
          <FontAwesomeIcon
            key={index}
            icon={faStarHalfStroke}
            className="rating-star"
          />
        );
      }
      return (
        <FontAwesomeIcon
          key={index}
          icon={faStarRegular}
          className="rating-star"
        />
      );
    });
  };
  const [modalShow, setModalShow] = React.useState(false);
  return (
    <>
      {" "}
      <section className=" Product_Rating container">
        <div className="heading_holder">
          <h3 className="heading_text mb-0">Average Ratings</h3>
        </div>
        <div className="rating_top_section">
          {" "}
          <div className="row align-items-center gy-4">
            {" "}
            {/* Rating Distribution */}{" "}
            <div className="col-lg-5">
              {" "}
              <div className="rating_card">
                {" "}
                <Average_Rating
                  product={product}
                  avg_rating={avg_rating}
                />{" "}
              </div>{" "}
            </div>{" "}
            {/* Overall Rating */}{" "}
            {totalReviews > 0 && (
              <div className="col-lg-4 mt-0">
                {" "}
                {/* <div className="overall_rating_card">
                  {" "}
                  <h2 className="overall_score">
                    {" "}
                    {averageRating.toFixed(1)} <span>/5</span>{" "}
                  </h2>{" "}
                  <div className="overall_stars">
                    {" "}
                    {renderStars(averageRating)}{" "}
                  </div>{" "}
                  <p>
                    {" "}
                    <strong>{totalReviews}</strong>{" "}
                    {totalReviews === 1 ? "Review" : "Reviews"}{" "}
                  </p>{" "}
                </div>{" "} */}
              </div>
            )}
            {/* Button */}
          </div>{" "}
        </div>
        {!hasReviewed && (
          <Green_btn btnText="Write Review" onClick={handleShowReviewModal} />
        )}
        <Modal
          show={showReviewModal}
          onHide={handleCloseReviewModal}
          centered
          size="lg"
          className="rating-modal"
        >
          {" "}
          <Modal.Header closeButton>
            {" "}
            <Modal.Title className="rating_title">
              {" "}
              Submit Your Review{" "}
            </Modal.Title>{" "}
          </Modal.Header>{" "}
          <Modal.Body className="rating_modal_body">
            {" "}
            <Submit_Your_Review
              product={product}
              handleCloseReviewModal={handleCloseReviewModal}
              setModalShow={setModalShow}
            />{" "}
          </Modal.Body>{" "}
        </Modal>{" "}
        <Success_Modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          successText="Submitted Successfully!"
        />{" "}
      </section>{" "}
    </>
  );
}
export default Product_Rating;
